import React, { useEffect, useState } from "react";
import training_icon1 from "../../assets/image/png/training_icon1.png";
import training_icon2 from "../../assets/image/png/training_icon2.png";
import training_icon4 from "../../assets/image/png/training_icon4.png";
import EnlistYourInstitute from "./EnlistYourInstitute";
import TrainingInstitutes from "./TrainingInstitutes";
import { getInstitutes } from "../../redux/slice/instituteSlice";
import DronelabAcademy from "./DronelabAcademy";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import AllCourses from "../CoursesDetailePage/AllCourses";
import AVPLCenters from "../CoursesDetailePage/AVPLCenters";
import AllWorkshops from "../CoursesDetailePage/AllWorkshops";
const TrainingCoursesHero = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const { totalPage, institutes } = useSelector((state) => state.institute);
  //  console.log("inst",institutes)
  const [activeTab, setActiveTab] = useState(id);
  const [showInstitutes, setShowInstitutes] = useState(false);
  const [searchQuery, setSearchQuery] = useState(""); // State for search query
  const [filteredInstitutes, setFilteredInstitutes] = useState([]); // Filtered institutes
  const [locationFilter, setLocationFilter] = useState(""); // New state for location filter
  const [allInstitutes, setAllInstitutes] = useState([]); // Store all institutes here

  const [uniqueLocations, setUniqueLocations] = useState([]);


   // Extract unique locations for dropdown
  //  const uniqueLocations = [...new Set(allInstitutes.map(inst => inst.location))].filter(Boolean);

  // Fetch institutes data on page change
  useEffect(() => {
    dispatch(getInstitutes({ page: page, limit: 4 }));
  }, [page, dispatch]);

  useEffect(() => {
    setActiveTab(id);
    setShowInstitutes(id === "1");
    window.scrollTo(0, 0);
  }, [id]);


  // Update allInstitutes only when new data is fetched
  // useEffect(() => {
  //   if (institutes.length > 0) {
      
  //     setAllInstitutes((prevInstitutes) => [...institutes]);
  //   }
  // }, [institutes]);
//   useEffect(() => {
//   if (institutes.length > 0) {
//     const statesOnly = institutes.map(inst => {
//       const parts = inst.address.split(',');
//       let state = parts.length >= 2 ? parts[parts.length - 2].trim() : '';
//       state = state.replace(/\d+/g, '').trim();

//       return {
//         ...inst,
//         address: state 
//       };
//     });

//     setAllInstitutes(statesOnly);
//   }
// }, [institutes]);


  // useEffect(() => {
  //   if (institutes.length > 0) {
  //     setAllInstitutes(institutes);
      
  //     const locations = institutes
  //       .map(inst => inst.address) 
  //       .filter((loc, index, self) => loc && self.indexOf(loc) === index);
  //     setUniqueLocations(locations);
  //   }
  // }, [institutes]);
useEffect(() => {
  if (institutes.length > 0) {

    // Only show institutes that completed profile
    const validInstitutes = institutes.filter(
      (inst) => inst?.instituteName && inst?.address
    );

    const statesOnly = validInstitutes.map((inst) => {
      const parts = (inst.address || "").split(",");

      let state = parts.length >= 2 ? parts[parts.length - 2].trim() : "";
      state = state.replace(/\d+/g, "").trim();

      return {
        ...inst,
        address: state,
      };
    });

    setAllInstitutes(statesOnly);

    const locations = [...new Set(statesOnly.map((inst) => inst.address))];
    setUniqueLocations(locations);
  }
}, [institutes]);


  useEffect(() => {
    // Filter institutes based on search query
    setFilteredInstitutes(
      allInstitutes.filter((institute) =>
        (institute?.instituteName || "").toLowerCase().includes(searchQuery.toLowerCase())
      )
    );
  }, [searchQuery, allInstitutes]);

  const handleSelect = (key) => {
    setActiveTab(key);
    setShowInstitutes(key === "1");
    navigate(`/training-courses/${key}`);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleLocationChange = (e) => {
    setLocationFilter(e.target.value);
  };

  // Inline styles for dropdown
  const listContainerStyle = {
    maxHeight: showInstitutes ? "500px" : "0",
    overflow: "hidden",
    transition: "max-height 1s ease-out",
  };

  const listStyle = {
    listStyle: "none",
    paddingLeft: "20px",
    marginTop: "10px",
    marginBottom: "0",
  };

  const listItemStyle = {
    position: "relative",
    marginBottom: "5px",
    paddingLeft: "25px",
    lineHeight: "24px",
    cursor: "pointer", // Makes the list item clickable
  };

  const bulletStyle = {
    position: "absolute",
    left: "0",
    top: "50%",
    transform: "translateY(-50%)",
    color: "#000",
    fontSize: "16px",
  };

  return (
    <div className="py-5">
      <div className="container">
        <div className="row">
          <div className="col-lg-3 ps-3 ps-lg-4 custom_top position-lg-sticky mb-3 h-100 overflow-y-auto" >
            <div className="training_detail_box bg-white p-3">
              <div className="d-flex cursor_pointer gap-4 align-items-center">
                <img width={20} src={training_icon1} alt="training_icon1" />
                <p
                  className={`mb-0 fs_24 fw-medium ff_inter ${
                    activeTab == 0 ? "custom-color" : "color_darkgray"
                  }`}
                  onClick={() => handleSelect(0)}
                  style={{ marginLeft: "-7px" }}
                >
                  All Drone Courses
                </p>
              </div>

              <div className="d-flex mt-3 cursor_pointer gap-3 align-items-center">
                <img width={23} src={training_icon2} alt="training_icon2" />
                <p
                  className={`mb-0 fs_24 fw-medium ff_inter ${
                    activeTab == 1 ? "custom-color" : "color_darkgray"
                  }`}
                  onClick={() => handleSelect(1)}
                >
                  Training Institutes
                </p>
              </div>
              <div className="d-flex mt-3 cursor_pointer gap-3 align-items-center">
                <img width={23} src={training_icon1} alt="training_icon3" />
                <p
                  className={`mb-0 fs_24 fw-medium ff_inter ${
                    activeTab == 2 ? "custom-color" : "color_darkgray"
                  }`}
                  onClick={() => handleSelect(2)}
                >
                  Deeptech Workshops
                </p>
              </div>
              <div className="d-flex mt-3 cursor_pointer gap-3 align-items-center">
                <img width={23} src={training_icon1} alt="service_icon" />
                <p
                  className={`mb-0 fs_24 fw-medium ff_inter ${
                    activeTab == 3 ? "custom-color" : "color_darkgray"
                  }`}
                  onClick={() => handleSelect(3)}
                >
                  Drone Service Centers
                </p>
              </div>
              {/* Training Institutes Search Bar */}
              {activeTab == 1 && (
                <div className="mt-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search Institutes"
                    value={searchQuery}
                    onChange={handleSearchChange}
                    style={{ marginBottom: "15px" }}
                  />

                  {/* Location Dropdown Filter */}
                  <select
                    className="form-select mb-3"
                    value={locationFilter}
                    onChange={handleLocationChange}
                  >
                    <option value="">All Locations</option>
                    {uniqueLocations.map((location, index) => (
                      <option key={index} value={location}>
                        {location}
                      </option>
                    ))}
                  </select>
                  {/* <div style={listContainerStyle}>
                    <ul style={listStyle}>
                      {filteredInstitutes.map((e) => (
                        <li
                          key={e.id}
                          style={listItemStyle}
                          onClick={() => navigate(`/training-institute/${e._id}`)}
                        >
                          <span style={bulletStyle}>•</span>
                          <a
                            href="#"
                            onClick={() => navigate(`/training-institute/${e._id}`)}
                            className="text-dark text-decoration-none"
                          >
                            {e.instituteName}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div> */}
                </div>
              )}
              

              {/* <div className="d-flex mt-3 cursor_pointer gap-3 align-items-center">
                <img width={20} src={training_icon4} alt="training_icon4" />
                <p
                  className={`mb-0 fs_24 fw-medium ff_inter ${
                    activeTab == 5 ? "custom-color" : "color_darkgray"
                  }`}
                  onClick={() => handleSelect(5)}
                >
                  Enlist your Institute
                </p>
              </div> */}
            </div>
          </div>

          <div className="col-lg-9">
            {activeTab == 0 && <AllCourses />}
            {/* {activeTab == 3 && <DronelabAcademy />} */}
            {activeTab == 1 && (
              <TrainingInstitutes 
                searchQuery={searchQuery} 
                locationFilter={locationFilter} 
              />
            )}
            {activeTab == 5 && <EnlistYourInstitute />}
            {activeTab == 2 && <AllWorkshops/>}
            {activeTab == 3 && <AVPLCenters />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrainingCoursesHero;
